import styled from 'styled-components';

import media from '../../../styles/media.style';
import { PAGE_WIDTH } from '../../../styles/variables.style';

export const Wrapper = styled.section`
  align-items: center;
  background-color: white;
  display: flex;
  flex-direction: column;
  margin: auto;
  max-width: ${PAGE_WIDTH}px;
  padding: 60px 0 80px;
  width: 100%;

  ${media.tabletL`
    padding: 150px 0;
  `};
`;

export const Title = styled.div`
  font-family: FuturaStd;
  font-size: 15px;
  font-weight: 500;
  letter-spacing: 0.1px;
  margin-bottom: 60px;
  position: relative;
  text-transform: uppercase;

  ${media.tabletP`
    font-size: 19px;
    margin-bottom: 125px;
  `};

  &::after {
    background-color: black;
    bottom: -25px;
    content: '';
    height: 2px;
    left: 50%;
    position: absolute;
    transform: translateX(-50%);
    width: 40px;
  }
`;

export const RangeContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 60px;
  max-height: ${({ visible }) => `${350 * visible - 50}px`};
  overflow-y: hidden;
  padding: 0 20px;
  transition: max-height 500ms ease-in-out;
  width: 100%;

  ${media.tabletP`
    margin-bottom: 80px;
    max-height: ${({ visible }) => `${350 * visible / 2 - 50}px`};
  `};

  ${media.tabletL`
    max-height: ${({ visible }) => `${350 * visible / 4 - 50}px`};
  `};
`;

export const Range = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 300px;
  justify-content: center;
  margin-bottom: 50px;
  width: 100%;

  ${media.tabletP`
    border-right: 2px solid #e0e0e0;
    width: 50%;

    &:nth-child(2n) {
      border-right: none;
    }
  `};

  ${media.tabletL`
    width: 25%;

    &:nth-child(2n) {
      border-right: 2px solid #e0e0e0;
    }

    &:nth-child(4n) {
      border-right: none;
    }
  `};
`;

export const RangeImage = styled.div`
  height: 130px;
  margin-bottom: 45px;
  width: 130px;
`;

export const RangeCategory = styled.div`
  font-family: FuturaStd;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.6px;
  margin-bottom: 10px;
  text-transform: uppercase;
`;

export const RangeName = styled.div`
  font-family: FuturaStd;
  font-size: 21px;
  font-weight: 500;
  letter-spacing: 0.1px;
  text-transform: uppercase;
  margin-bottom: 25px;
`;

export const ViewProductRange = styled.div`
  font-family: FuturaStd;
  font-size: 14px;
  font-weight: 900;
  text-decoration: underline;
  text-transform: uppercase;
`;

export const Button = styled.div`
  align-items: center;
  background-color: black;
  color: white;
  cursor: pointer;
  display: flex;
  font-family: FuturaStd;
  font-size: 13px;
  height: 60px;
  justify-content: center;
  letter-spacing: 0.8px;
  padding: 0 25px;
  text-transform: uppercase;

  ${media.tabletP`
    font-size: 16px;
    height: 90px;
    padding: 0 85px;
  `};
`;

export const contentTypeToCategory = {
  productRangeSkinBodyCare: 'Skin / Body Care',
  productRangeHairCare: 'Hair Care',
  productRangeHairColor: 'Hair Color',
  productRangeMakeUp: 'Make Up',
  productRangeMens: "Men's",
  productRangePerm: 'Perm',
  productRangeStyling: 'Styling',
};

export const contentTypeToUrl = {
  productRangeSkinBodyCare: 'skin-body-care',
  productRangeHairCare: 'hair-care',
  productRangeHairColor: 'hair-color',
  productRangeMakeUp: 'make-up',
  productRangeMens: 'mens',
  productRangePerm: 'perm',
  productRangeStyling: 'styling',
};



// WEBPACK FOOTER //
// ./src/pages/HomePage/KeyProductLine/KeyProductLine.style.js